var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8574 7.50021C13.8574 3.71311 10.7873 0.643066 7.00021 0.643066C3.21311 0.643066 0.143066 3.71311 0.143066 7.50021C0.143066 11.2873 3.21311 14.3574 7.00021 14.3574C10.7873 14.3574 13.8574 11.2873 13.8574 7.50021ZM12.9431 7.50021C12.9431 10.7824 10.2824 13.4431 7.00021 13.4431C3.71806 13.4431 1.05735 10.7824 1.05735 7.50021C1.05735 4.21806 3.71806 1.55735 7.00021 1.55735C10.2824 1.55735 12.9431 4.21806 12.9431 7.50021ZM6.54307 3.95735V4.75735C6.54307 5.00983 6.74774 5.2145 7.00021 5.2145C7.25268 5.2145 7.45735 5.00983 7.45735 4.75735V3.95735C7.45735 3.70488 7.25268 3.50021 7.00021 3.50021C6.74774 3.50021 6.54307 3.70488 6.54307 3.95735ZM6.54307 6.24307V11.0431C6.54307 11.2955 6.74774 11.5002 7.00021 11.5002C7.25268 11.5002 7.45735 11.2955 7.45735 11.0431V6.24307C7.45735 5.99059 7.25268 5.78592 7.00021 5.78592C6.74774 5.78592 6.54307 5.99059 6.54307 6.24307Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoErrorIcon);
export default __webpack_public_path__ + "static/media/info-error-icon.f26650ffe5497137dbda284e1997bc83.svg";
export { ForwardRef as ReactComponent };